<template>
    <MainContainer>
        <div class="kontenblaetter">
            <h2>Kontenblatt</h2>
            <FiBuKontenblaetterFilter
                :finanzkonto="finanzkonto"
                :zuschusskonto="zuschusskonto"
                :ruecklagenkonto="ruecklagenkonto"
                :buchungskonto="buchungskonto"
                :jaCategories="jaCategories"
                :furtherCategories="furtherCategories"
                :data="data"
                :validation="validation"
                @submit="updateFilter"
                @printKontenblaetter="setBusyState"
                @kontenblaetterPrinted="setBusyState"
                @fetchBuchungsKnt="fetchBuchungskontos"
                @fetchFinanzKnt="fetchFinanzkontos"
                @fetchZuschussKnt="fetchZuschusskonten"
                @fetchRuecklagenKnt="fetchRuecklagenkonten"
                @resetData="resetData"
                @popupinfo="showPopupInfo"
            />
            <FiBuKontenblaetterList
                :filter="filter"
                :data="data"
                :finanzkonto="finanzkonto"
                :zuschusskonto="zuschusskonto"
                :ruecklagenkonto="ruecklagenkonto"
                :buchungskonto="buchungskonto"
                :category="category"
                @buchungDeleted="fetchKontenblaetter"
            />
        </div>
        <PopUpChecker />
        <div
            class="loading-modal container-fluid d-flex justify-content-center align-items-center p-3"
            v-if="busy"
        >
            <div class="d-flex flex-column align-items-center">
                <h6 class="mb-3">Daten werden geladen. Bitte haben Sie etwas Geduld!</h6>
                <b-spinner style="width: 3rem; height: 3rem;" label="Large Spinner"></b-spinner>
            </div>
        </div>
    </MainContainer>
</template>
<script>
import MainContainer from "@/components/MainContainer/MainContainer.vue";
import FiBuKontenblaetterFilter from "@/components/FiBuKontenblaetterFilter/FiBuKontenblaetterFilter.vue";
import FiBuKontenblaetterList from "@/components/FiBuKontenblaetterList/FiBuKontenblaetterList.vue";
import Size from "@/mixins/Size/Size";
import {ApiFactory} from "@/api/ApiFactory";
import Validation from "@/mixins/Validation/Validation";
import CommonView from "@/mixins/CommonView/CommonView";
import PopUpChecker from "@/components/PopUpChecker/PopUpChecker.vue";

const FiBuKontenblaetterApi = ApiFactory.get('fibuKontenblaetterApi');
const FiBuBuchungskontoApi = ApiFactory.get('fibuBuchungskonto');
const FiBuFinanzkontoApi = ApiFactory.get('fibuFinanzkonto');
const FiBuZuschusskontoApi = ApiFactory.get('fibuZuschusskonto');
const FiBuRuecklagenkontoApi = ApiFactory.get('fibuRuecklagenkonto');
const FiBuCategoryApi = ApiFactory.get('fibuCategory');

export default {
    name: "Kontenblatt",
    mixins: [Size, Validation, CommonView],
    components: {
        PopUpChecker,
        MainContainer,
        FiBuKontenblaetterFilter,
        FiBuKontenblaetterList
    },
    data() {
        return {
            api: FiBuKontenblaetterApi,
            prefetch: false,
            filter: {},
            titles: [],
            data: {},
            busy: false,
            buchungskonto: {
                busy: false,
                items: [],
                options: []
            },
            finanzkonto: {
                busy: false,
                items: [],
                options: []
            },
            zuschusskonto: {
                busy: false,
                items: [],
                options: []
            },
            ruecklagenkonto: {
                busy: false,
                items: [],
                options: []
            },
            category: {
                busy: false,
                items: [],
                options: []
            },
            validation: {}
        }
    },
    created() {
        this.fetchCategories();
    },
    methods: {
        async fetchKontenblaetter() {
            this.busy = true;

            const response = await FiBuKontenblaetterApi.get({
                filter: this.filter
            });

            if (response.ok) {
                for (const property in response.json.konten) {
                    response.json.konten[property].buchungen.map(konto => {
                        konto.categories = konto.categories.split(',');
                        return konto;
                    })
                }

                this.data = response.json.konten;


                this.validation = {};
            } else {
                this.validation = response.json.validation;
            }

            this.busy = false;
        },
        async fetchBuchungskontos() {
            this.buchungskonto.busy = true;

            const response = await FiBuBuchungskontoApi.get();

            if (response.ok) {
                this.buchungskonto.items = response.json.collection;
                this.buchungskonto.options = response.json.collection.map(item => {
                    return {
                        text: `${item.kontonr} - ${item.text}`,
                        value: item.id
                    }
                });

                this.buchungskonto.options.splice(0, 0, {text: 'Konto wählen', value: null});
            }

            this.buchungskonto.busy = false;
        },
        async fetchFinanzkontos() {
            this.finanzkonto.busy = true;

            const response = await FiBuFinanzkontoApi.get();

            if (response.ok) {
                this.finanzkonto.items = response.json.collection;
                this.finanzkonto.options = response.json.collection.map(item => {
                    return {
                        text: `${item.kontonr} - ${item.text}`,
                        value: item.id
                    }
                });

                this.finanzkonto.options.splice(0, 0, {text: 'Konto wählen', value: null});
            }

            this.finanzkonto.busy = false;
        },
        async fetchZuschusskonten() {
            this.zuschusskonto.busy = true;

            const response = await FiBuZuschusskontoApi.get();

            if (response.ok) {
                this.zuschusskonto.items = response.json.collection;
                this.zuschusskonto.options = response.json.collection.map(item => {
                    return {
                        text: item.text,
                        value: item.id
                    }
                });

                this.zuschusskonto.options.splice(0, 0, {text: 'Konto wählen', value: null});
            }

            this.zuschusskonto.busy = false;
        },
        async fetchRuecklagenkonten() {
            this.ruecklagenkonto.busy = true;

            const response = await FiBuRuecklagenkontoApi.get();

            if (response.ok) {
                this.ruecklagenkonto.items = response.json.collection;
                this.ruecklagenkonto.options = response.json.collection.map(item => {
                    return {
                        text: item.text,
                        value: item.id
                    }
                });

                this.ruecklagenkonto.options.splice(0, 0, {text: 'Konto wählen', value: null});
            }

            this.ruecklagenkonto.busy = false;
        },
        async fetchCategories() {
            this.category.busy = true;

            const response = await FiBuCategoryApi.get();

            if (response.ok) {
                this.category.items = response.json.collection;
                this.category.options = response.json.collection.map(item => {
                    return {
                        text: item.description,
                        value: item.id
                    }
                });
            }

            this.category.busy = false;
        },
        updateFilter(filter) {
            this.data = {}
            this.filter = Object.assign({}, filter);
            this.fetchKontenblaetter();
        },
        fetchErrorHandling(response) {
            this.handleValidationData(response,)
        },
        resetData() {
            this.data = {};
        },
        scrollToAnchorPoint(refName) {
            const el = this.$refs[refName];
            el.scrollIntoView({behavior: 'smooth', block: 'center'});

            this.$router.replace({
                path: `/fibu/kontenblaetter`
            });
        },
        setBusyState(value) {
            this.busy = value;
        },
        showPopupInfo() {
            this.$bvModal.show('pop-up-checker');
        }
    },
    computed: {
        jaCategories() {
            let categories = this.category.items.filter(item => item.groups.includes(1));

            return categories.map(item => ({text: item.description, value: item.id}));
        },
        furtherCategories() {
            let categories = this.category.items.filter(item => !item.groups.includes(1))
            let furtherCategories = categories.map(item => ({text: item.description, value: item.id}));
            furtherCategories.splice(0, 0, {text: 'alle Auswählen', value: null});

            return furtherCategories;
        }
    }
}
</script>